import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { FeedKey, useGetGroupFollowersQuery, GroupFragment } from 'api';
import { Loaders, ProfilesWidget } from 'components';

import { useGetGroupFollowers } from 'features/groups/hooks';

interface IProps {
  group: GroupFragment;
}

const Members: FC<IProps> = ({ group }) => {
  const { t } = useTranslation();
  const variables = { id: group.id, limit: 10, feed: FeedKey.Group };
  const refetchQueryKey = useGetGroupFollowersQuery.getKey({ data: variables });
  const { results, count, isInitialLoad, isEmpty } = useGetGroupFollowers({ data: variables });

  if (isInitialLoad) {
    return <Loaders.Widget />;
  }

  if (isEmpty) {
    return null;
  }

  return (
    <ProfilesWidget
      maxResults={8}
      maxWidth={170}
      link={`/group/${group.id}/members`}
      results={results.map(feedFollow => feedFollow.followed_by_user)}
      title={t('components:xMember', { count })}
      refetchQueryKeys={[refetchQueryKey]}
    />
  );
};

export default Members;
